import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-route",
  "use": "icon-route-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-route\"><path d=\"M783.274667 465.749333h-550.4a148.138667 148.138667 0 0 1 0-296.362666h562.346666v84.650666l220.842667-127.061333L795.306667 0v84.650667H232.874667a232.874667 232.874667 0 0 0 0 465.749333h550.4a148.138667 148.138667 0 1 1 0 296.362667H223.232V762.026667L0.853333 892.672l222.293334 123.818667v-85.077334h560.042666a232.874667 232.874667 0 0 0 0-465.664z\" p-id=\"2270\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/route.svg
// module id = bdRZ
// module chunks = 197